import 'flatpickr/dist/flatpickr.css';
import './inline-flatpickr.css';

import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';
import Flatpickr, { DateTimePickerProps } from 'react-flatpickr';
import { Control, Controller, ValidateResult } from 'react-hook-form';

import { CalandarSelectIcon } from '../../icons/calandar-select';
type InlineFlatpickrProps = {
  id: string;
  value: string;
  placeholder?: string;
  name: string;
  validation?: (value: string) => ValidateResult;
  control: Control;
  dataTestId?: string;
  options: DateTimePickerProps['options'];
};

export const InlineFlatpickr = ({
  control,
  id,
  name,
  placeholder,
  validation,
  dataTestId,
  options,
}: InlineFlatpickrProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: t('common.field-required'),
        validate: val => {
          return validation ? validation(val) : true;
        },
      }}
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <div className="relative w-full">
            <div className="absolute left-3 top-5 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none">
              <CalandarSelectIcon />
            </div>
            <Flatpickr
              id={id}
              className="h-9 grow px-2 pl-8 font-inter text-description outline-0 border border-neutral-b4 rounded-10 w-full"
              data-testid={dataTestId}
              placeholder={placeholder}
              onClose={onBlur}
              onChange={val => {
                onChange(val[0]);
              }}
              value={value}
              required
              options={options}
            />
          </div>
        );
      }}
    />
  );
};
